import { SALARYHEADERMAPPING } from './constants/salary_c';
import _v from './vars';
import _u from './util';
import _ from 'lodash';

function formatSalary(sal) {
	return String(sal).replace(/(\d?\d\d)(\d\d\d$)/, ',$1,$2').replace(/^,/, '');
}

function getSalaryWidg() {
	
	let gQlCityQuery = {	
	  query: `
		query fetchDmaData ($cityZip:String!) {
		  getDmaData(cityorzip: $cityZip) {
			city
			state
			dmac
			region
		  }
		}
	  `,	  
	  variables: {
			"cityZip": userZip
		}  
	};

	fetch("https://salarytool." + _v.slryApiDom + "medscape.com/graphql", {
	   method: "POST",
	   headers: {
		"Content-Type": "application/json"
	   },
	   body: JSON.stringify(gQlCityQuery)
	}).then(res => { return res.json();	}).then(resData => {	
		
		resData = resData.data.getDmaData[0];
	  
		let modifiedHomepageId = userHpId;
		modifiedHomepageId == '50' ? modifiedHomepageId = "18" : modifiedHomepageId = modifiedHomepageId;
		modifiedHomepageId == '18' ? modifiedHomepageId = "34" : modifiedHomepageId = modifiedHomepageId;
		modifiedHomepageId == '1' ? modifiedHomepageId = "3" : modifiedHomepageId = modifiedHomepageId;
		let gQlAvgQuery = {
			query:
				`
				query FetchAvgLikeYou($homepageId: String!, $dmac: String!, $state: String!, $region: String!, $yearExp: String, $employee: String, $salaryYear: String) {
					avgLikeYou(homepageId: $homepageId, dmac: $dmac, state: $state, region: $region, yearExp: $yearExp, employee: $employee, salaryYear: $salaryYear) {
						widgetData {
						  level
						  totalCount
						  avg_salary
						  nationalPct
						  metrics
						}
					}
				}
			  `
		  ,
			variables: {
				homepageId: modifiedHomepageId,
				dmac: resData.dmac,
				state: resData.state,
				region: resData.region,
				yearExp: "1,100",
				employee: "",
				salaryYear: "2020"
			}
		};

		var headerandDataObject = {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify(gQlAvgQuery)
		};
		_u.apiPost("https://salarytool." + _v.slryApiDom + "medscape.com/graphql", headerandDataObject)
		.then(function (json) {
			if (typeof json != 'undefined') {
				let widgetData = json.data.avgLikeYou.widgetData;
				let specialistName = SALARYHEADERMAPPING.mapping[userHpId].specialist;

				if (widgetData && specialistName) {
					if (document.getElementById('salary-explorer-widget') != null) {
						document.getElementById('salary-explorer-widget').classList.add("active");
					};
					document.getElementById('pers-salary-explorer-subheader').innerText = "Average salary for " + specialistName + " like you";
					let pctArr = [];
					let minValues = [];
					let maxValues = [];
					_u.qS('.pers-salary-explorer-avg-salary').innerHTML = formatSalary(widgetData.avg_salary);
					widgetData.metrics.forEach(function (salObj, idx) {
						let resIdx = idx;
						Object.keys(salObj).forEach(function (key, idx) {
							let graphBar = _u.qS('.slry-bar-graph-bar')[resIdx];
							graphBar.innerHTML = '<div class="slry-bar-graph-pct"></div>';
							graphBar.querySelector('.slry-bar-graph-pct').classList.add('active');
							pctArr.push(Number(salObj[key].pct.replace('<1','0')));
							minValues.push(salObj[key].minSalary);
							maxValues.push(salObj[key].maxSalary);
						})
					});
					_u.qS('.from-salary').innerHTML = '$' + formatSalary(Math.min.apply(Math, minValues));
					_u.qS('.to-salary').innerHTML = '$' + formatSalary(Math.max.apply(Math, maxValues));
					let pctArrSort = pctArr.slice();
					pctArrSort.sort(function (a, b) {
						return a - b
					});
					let highPct = pctArrSort[pctArrSort.length - 1];
					let pctRatio = 100 / highPct;
					pctArr.forEach(function (pct, idx) {
						if (pct == 0) {
							_u.qS('.slry-bar-graph-bar')[idx].style.height = '1px';
						} else {
							_u.qS('.slry-bar-graph-bar')[idx].style.height = (pct * pctRatio) + '%';
						}
						if (pct == highPct) {
							_u.qS('.slry-bar-graph-bar')[idx].style.backgroundColor = '#6f7489';
							_u.qS('.slry-bar-graph-bar')[idx].style.opacity = '0.7019624255952381';
						} else if ((pct * pctRatio) < 20) {
							_u.qS('.slry-bar-graph-bar')[idx].style.backgroundColor = '#b4bdce';
							_u.qS('.slry-bar-graph-bar')[idx].style.opacity = '0.4000000059604645';
						} else {
							_u.qS('.slry-bar-graph-bar')[idx].style.backgroundColor = '#b4bdce';
							_u.qS('.slry-bar-graph-bar')[idx].style.opacity = '0.699999988079071';
						}
					});
				}
			}
		}).catch(err => {
			console.log(err);
		});	  
	  
	})
	.catch(err => {
	  console.log(err);
	});
}

export default getSalaryWidg;